<template>
	<div class="recension-card">
		<div class="author">
			<div class="imgwrap">
				<img :src="data.imageUrl" alt="" />
			</div>
			<div class="author-info">
				<h4>{{ data.name }}</h4>
				<p>{{ data.position }}</p>
			</div>
		</div>
		<div v-if="data.subtext" class="subtext">
			<h5>{{ data.subtext }}</h5>
		</div>
		<p v-html="data.text"></p>
	</div>
</template>
<script setup>
// eslint-disable-next-line no-undef
defineProps({
	data: {
		imageUrl: String,
		name: String,
		position: String,
		text: String,
		subtext: String,
	},
});
</script>
<style scoped lang="scss">
.recension-card {
	// margin-top: 5rem;
	text-align: left;
	max-width: 700px;
	width: 90%;

	// height: 300px;
	// box-shadow: 0 5px 13px 0 rgb(0 0 0 / 10%);
	color: $section-color;
	padding: 2rem 3rem;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;

	&:hover {
		.imgwrap img {
			transform: scale(1.1);
		}
	}

	.subtext {
		flex-grow: 1;
		display: flex;
		align-items: center;
		margin: 0 0 3rem;

		h5 {
			color: $section-color;
			font-style: italic;
			font-weight: 700;
			font-size: 18px;
		}
	}

	p {
		font-size: 18px;
	}

	.author {
		display: flex;
		flex-direction: row;

		.imgwrap {
			padding: 1rem 3rem 1rem 0;

			img {
				width: 110px;
				transition-duration: 0.3s;
			}
		}

		.author-info {
			margin-left: 2rem;
			display: flex;
			flex-direction: column;
			font-size: 32px;

			h4 {
				color: var(--es-background-color);
				white-space: nowrap;
				margin-top: 1.5rem;
			}

			p {
				margin: 0;
				color: $second-app-color-alt;
				font-size: 18px;
			}
		}
	}
}

@media screen and (width <= 768px) {
	.recension-card {
		width: 100%;

		p {
			font-size: 15px;
		}

		.subtext h5 {
			font-size: 15px;
		}

		.author {
			.imgwrap {
				padding-right: 1rem;

				img {
					width: 70px;
				}
			}

			.author-info {
				margin-left: 0;

				h4 {
					font-size: 20px;
				}

				p {
					font-size: 15px;
				}
			}
		}
	}
}
</style>
